<template>
  <div class="footer-block">
    <div class="container">
      <p>Make It Cheaper Financial Services Limited. Registered in England &amp; Wales Registered No: 07548195 Registered company address: 4th Floor, The Minster Building, 21 Mincing Lane, London, EC3R 7AG Make It Cheaper Financial Services Limited is authorised and regulated by the Financial Conduct Authority</p>
      <p>Make It Cheaper Limited. Registered in England &amp; Wales Registered No: 05949018 Registered company address: 4th Floor, The Minster Building, 21 Mincing Lane, London, EC3R 7AG</p>
      <div class="footer-block__footer">
        <span>&copy; Make It Cheaper Limited 2019</span>
        <div class="footer-block__links">
          <a class="footer-block__link" href="https://www.makeitcheaper.com/company-information/terms-conditions" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
          <span class="footer-block__links-divider"> - </span>
          <a class="footer-block__link" href="https://www.makeitcheaper.com/company-information/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBlock'
}
</script>

<style lang="scss">
.footer-block {
  padding: $spacing-40 0 $spacing-24;
  background-color: $footer-bg;
  color: $white;
  text-align: left;

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: $spacing-40;
    padding-top: $spacing-32;
    border-top: 1px solid $white;
  }

  &__link {
    text-decoration: underline;
  }

  &__links-divider {
    padding: $spacing-0 $spacing-8;
  }

  @media (max-width: $screen-md) {
    &__footer {
      display: flex;
      flex-direction: column;
      align-items: initial;
    }

    &__links {
      display: flex;
      justify-content: space-between;
      margin-top: $spacing-8;
      width: 100%;
    }

    &__links-divider {
      display: none;
    }
  }
}
</style>
